// src/utils/helpers.js
import { Trans } from 'react-i18next';
import i18n from 'i18next';
import { Input, notification } from 'antd';
import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import {
  PiNumberCircleEight,
  PiNumberCircleFive,
  PiNumberCircleFour,
  PiNumberCircleNine,
  PiNumberCircleOne,
  PiNumberCircleSeven,
  PiNumberCircleSix,
  PiNumberCircleThree,
  PiNumberCircleTwo,
  PiNumberCircleZero,
} from 'react-icons/pi';
import dayjs from 'dayjs';
import phone from 'phone';
import { saveAs } from 'file-saver';
import IntlMessage from '../components/ui/IntlMessage';
import { formatDateTimeDefault } from 'utils/date';
import { decryptInviteHash } from 'utils/crypto';
import { getPhoneMeta } from './phone';
import { formatPhoneNumberByCountry } from './phoneFormatter';
import { isValidCnpj, isValidCpf } from 'utils/validation';

const tmr = {};
let tmrDebounce;
let workingQueue = {};

export const getUrlFromBrowser = () => window.location.href;
/*
export const getUrlByLocation = location => {
  return location.pathname + location.search;
};

export const getUrlQueryStringByLocation = location => {
  const queryString = new URLSearchParams(location.search);

  // Convert all Query String parameters into an object
  const queryParams = {};
  for (const [key, value] of queryString.entries()) {
    queryParams[key] = value;
  }

  return queryParams;
};

export const updateUrlByQueryStringObject = (queryStringObj, navigate) => {
  const queryString = new URLSearchParams(queryStringObj).toString();

  // Atualiza a URL sem recarregar os componentes
  const updateURL = () => {
    navigate({ search: `?${queryString}` });
  };
};*/
export const onProduction = () => {
  return !getUrlFromBrowser().includes('localhost');
};

/**
 * Determines if detailed logs should be shown.
 * Shows logs when: running on localhost OR in homologation mode (even if online).
 * This is useful for support/debugging in homologation environments.
 *
 */
export const shouldShowLogs = () => {
  // Always show logs on localhost
  if (!onProduction()) return true;

  // Also show logs when in homologation mode (even if online)
  const runtimeMode = import.meta.env.VITE_RUNTIME_MODE;
  return runtimeMode === 'homologation';
};

export const sort = (a, b, key) => {
  if (!key) {
    if (!isNaN(a)) a = Number(a);
    if (!isNaN(b)) b = Number(b);

    if (typeof a === 'number' && typeof b === 'number') {
      return a - b;
    }

    if (typeof a === 'string' && typeof b === 'string') {
      a = a.toLowerCase();
      b = b.toLowerCase();

      return a > b ? 1 : b > a ? -1 : 0;
    }
  } else {
    if (!isNaN(a[key])) a[key] = Number(a[key]);
    if (!isNaN(b[key])) b[key] = Number(b[key]);

    if (typeof a[key] === 'number' && typeof b[key] === 'number') {
      return a[key] - b[key];
    }

    if (typeof a[key] === 'string' && typeof b[key] === 'string') {
      a = a[key].toLowerCase();
      b = b[key].toLowerCase();

      return a > b ? 1 : b > a ? -1 : 0;
    }
  }
};

export const translateWord = (inComponent, key) => {
  const returnObject = typeof inComponent === 'boolean' && inComponent;
  const id = key || inComponent;
  const t = <Trans i18nKey={id} />;
  return returnObject ? t : i18n.t(id);
};

/**
 * @function translateX
 * @description Safe translation helper. If id is not a string, return it as-is.
 *              Optional replacements are applied as raw strings (no double i18n).
 */
// export const translateX = (id, replaceFrom = [], replaceTo = []) => {
//   // If a ReactNode or any non-string was passed, do NOT break it.
//   if (typeof id !== 'string') return id;
//
//   let t = i18n.t(id);
//
//   if (Array.isArray(replaceFrom) && Array.isArray(replaceTo) && replaceFrom.length > 0) {
//     replaceFrom.forEach((from, idx) => {
//       const to = replaceTo[idx] ?? '';
//       // raw replace; if you want i18n on replace values, call translateX before passing here
//       t = t.replace(from, to);
//     });
//   }
//
//   return t;
// };

export const isValidEmail = email => {
  // Updated regex to follow RFC 5322 more strictly
  const regex =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  if (Array.isArray(email)) {
    let success = true;
    email.map(e => !regex.test(e) && (success = false));
    return success;
  } else {
    return regex.test(email);
  }
};

export const isValidUrl = website => {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i'
  ); // fragment locator
  return !!pattern.test(website);
};

// export const isValidCpf = cpf => {
//   if (!cpf) return;
//
//   cpf = returnOnlyNumbers(cpf);
//
//   if (cpf === '') return false;
//
//   // remove invalids cpfs
//   if (
//     cpf.length !== 11 ||
//     cpf === '00000000000' ||
//     cpf === '11111111111' ||
//     cpf === '22222222222' ||
//     cpf === '33333333333' ||
//     cpf === '44444444444' ||
//     cpf === '55555555555' ||
//     cpf === '66666666666' ||
//     cpf === '77777777777' ||
//     cpf === '88888888888' ||
//     cpf === '99999999999'
//   ) {
//     return false;
//   }
//
//   // check the first digit
//   let add = 0;
//   for (let i = 0; i < 9; i++) {
//     add += parseInt(cpf.charAt(i)) * (10 - i);
//   }
//
//   let rev = 11 - (add % 11);
//
//   if (rev === 10 || rev === 11) rev = 0;
//   if (rev !== parseInt(cpf.charAt(9))) return false;
//
//   // check the second digit
//   add = 0;
//   for (let i = 0; i < 10; i++) {
//     add += parseInt(cpf.charAt(i)) * (11 - i);
//   }
//
//   rev = 11 - (add % 11);
//
//   if (rev === 10 || rev === 11) rev = 0;
//
//   return rev === parseInt(cpf.charAt(10));
// };
//
// export const isValidCnpj = cnpj => {
//   if (typeof cnpj === 'undefined') return false;
//
//   cnpj = returnOnlyNumbers(cnpj);
//
//   if (
//     cnpj === '' ||
//     cnpj.length !== 14 ||
//     cnpj === '00000000000000' ||
//     cnpj === '11111111111111' ||
//     cnpj === '22222222222222' ||
//     cnpj === '33333333333333' ||
//     cnpj === '44444444444444' ||
//     cnpj === '55555555555555' ||
//     cnpj === '66666666666666' ||
//     cnpj === '77777777777777' ||
//     cnpj === '88888888888888' ||
//     cnpj === '99999999999999'
//   ) {
//     return false;
//   }
//
//   // check digits
//   let length = cnpj.length - 2;
//   let number = cnpj.slice(0, length);
//   let digits = cnpj.slice(length);
//   let sum = 0;
//   let suffix = length - 7;
//
//   for (let i = length; i >= 1; i--) {
//     sum += number.charAt(length - i) * suffix--;
//     if (suffix < 2) {
//       suffix = 9;
//     }
//   }
//
//   let resultado = sum % 11 < 2 ? 0 : 11 - (sum % 11);
//
//   if (resultado.toString() !== digits.charAt(0)) {
//     return false;
//   }
//
//   length = length + 1;
//   number = cnpj.slice(0, length);
//   sum = 0;
//   suffix = length - 7;
//
//   for (let i = length; i >= 1; i--) {
//     sum += number.charAt(length - i) * suffix--;
//     if (suffix < 2) {
//       suffix = 9;
//     }
//   }
//   resultado = sum % 11 < 2 ? 0 : 11 - (sum % 11);
//   return resultado.toString() === digits.charAt(1);
// };

export const isCpfOrCnpj = value => {
  if (!value) return false;

  if (isValidCnpj(value)) return 'cnpj';
  if (isValidCpf(value)) return 'cpf';

  return false;
};

/*
export const isValidCpfCnpj = value => {
  if (!value) return false;

  const v = returnOnlyNumbers(value);
  if (v?.toString().length <= 11) {
    return isValidCpf(v);
  } else {
    return isValidCnpj(v);
  }
};
*/

// export const isValidZip = cep => {
//   if (!cep) return false;
//
//   const maskedCep = applyNumberMask(returnOnlyNumbers(cep), '99999-999');
//   const regex = /[0-9]{5}-[\d]{3}/;
//   return regex.test(maskedCep);
// };

export const isValidCep = cep => {
  if (!cep) return false;

  const maskedCep = applyNumberMask(returnOnlyNumbers(cep), '99999-999');
  const regex = /[0-9]{5}-[\d]{3}/;
  return regex.test(maskedCep);
};

// Portuguese postal code (Codigo Postal): 7 digits, format NNNN-NNN
export const isValidCodigoPostal = cp => {
  if (!cp) return false;

  const digits = returnOnlyNumbers(cp);
  return /^[0-9]{4}[0-9]{3}$/.test(digits);
};

export const parseCodigoPostalToDisplay = str => {
  if (!str) return;
  return applyNumberMask(returnOnlyNumbers(str), '9999-999');
};

export const isValidDate = date => {
  return date instanceof Date && !isNaN(date);
};

export const returnOnlyNumbers = str => {
  if (!str) return;
  return str?.toString()?.replace(/\D/g, '');
};

export const applyNumberMask = (value, mask, acceptSpace) => {
  if (!value) return;

  let result = '';

  acceptSpace = false;

  // Look for placeholders (9 or #) in the mask instead of digits [0-9]
  const rule = acceptSpace ? '[9#] ' : '[9#]';
  const regex = new RegExp(rule, 'ig');

  let inc = 0;
  Array.from(value).forEach((letter, index) => {
    if (!mask[index + inc]) return result;

    if (!mask[index + inc].match(regex)) {
      setMask(index);
    }

    result += letter;
  });

  return result;

  function setMask(index) {
    result += mask[index + inc];
    inc++;

    if (mask[index + inc] && !mask[index + inc].match(regex)) setMask(index);
  }
};

export const toast = (type, title, message, duration = 4.5, key) => {
  if (!type) return console.error('type missing in toast() helper function!');

  // eslint-disable-next-line default-case
  switch (type.toLowerCase()) {
    case 's':
      type = 'success';
      break;

    case 'e':
    case 'f':
      type = 'error';
      break;

    case 'w':
      type = 'warning';
      break;

    case 'i':
      type = 'info';
      break;
  }

  if (!['success', 'error', 'warning', 'info'].includes(type)) {
    console.error(`unknowing type '${type}' in toast() helper function!`);
    return;
  }

  notification[type]({
    message: title,
    description: message,
    duration: duration,
    key: key,
  });
};

// export const modal = options => {
//   if (!options) {
//     return console.error(`'options' missing in modal() helper function!`);
//   } else if (!options.type) {
//     return console.error(`'options.type' missing in modal() helper function!`);
//   } else if (!options.title) {
//     return console.error(`'options.title' missing in modal() helper function!`);
//   } else if (!options.message) {
//     return console.error(
//       `'options.message' missing in modal() helper function!`,
//     );
//   }
//
//   let type = options.type;
//
//   // eslint-disable-next-line default-case
//   switch (type.toLowerCase()) {
//     case 's':
//       type = 'success';
//       break;
//
//     case 'e':
//     case 'f':
//       type = 'error';
//       break;
//
//     case 'w':
//       type = 'warning';
//       break;
//
//     case 'i':
//       type = 'info';
//       break;
//
//     case 'c':
//       type = 'confirm';
//       break;
//   }
//
//   if (!['success', 'error', 'warning', 'info', 'confirm'].includes(type)) {
//     console.error(`unknowing type '${type}' in modal() helper function!`);
//     return;
//   }
//
//   Modal[type]({
//     title: options.title,
//     content: options.message,
//     cancelText: options.cancelText || 'Cancel',
//     okText: options.okText || 'OK',
//     onOk: options.onOk || null,
//     onCancel: options.onCancel || null,
//     wrapClassName: 'modal-without-title',
//   });
// };

export const generateCode = (levels, passwordLength = 4) => {
  const fruits = [
    'abacaxi',
    'banana',
    'caju',
    'damasco',
    'figo',
    'goiaba',
    'kiwi',
    'limao',
    'manga',
    'nectarina',
    'laranja',
    'papaia',
    'framboesa',
    'morango',
    'tangerina',
    'melancia',
    'ameixa',
    'uva',
    'graviola',
    'jaca',
    'mamao',
  ];

  const colors = [
    'amarelo',
    'azul',
    'verde',
    'vermelho',
    'roxo',
    'laranja',
    'rosa',
    'cinza',
    'preto',
    'branco',
    'marrom',
    'bege',
    'ciano',
    'magenta',
    'turquesa',
    'prata',
    'ouro',
    'bronze',
    'lilas',
    'violeta',
  ];

  const countries = [
    'alemanha',
    'argentina',
    'australia',
    'brasil',
    'canada',
    'china',
    'dinamarca',
    'egito',
    'espanha',
    'franca',
    'grecia',
    'india',
    'italia',
    'japao',
    'mexico',
    'noruega',
    'polonia',
    'portugal',
    'russia',
    'suica',
    'suecia',
    'tailandia',
    'turquia',
    'ucrania',
    'venezuela',
    'chile',
    'colombia',
    'equador',
    'peru',
    'uruguai',
  ];

  const flowers = [
    'rosa',
    'margarida',
    'orquidea',
    'girassol',
    'violeta',
    'cravo',
    'tulipa',
    'begonia',
    'lirio',
    'azaleia',
    'hibisco',
    'jasmine',
    'petunia',
    'bromelia',
    'dalia',
    'horteia',
    'camelia',
    'calandiva',
    'gardenia',
    'primavera',
    'suculenta',
    'alegria',
    'anturio',
  ];

  let lightPassword = [...fruits, ...colors, ...countries, ...flowers];

  if (!levels) {
    const index = Math.floor(Math.random() * lightPassword.length);
    return lightPassword[index];
  } else if (!Array.isArray(levels)) {
    levels = $normalizeLevels(levels);
  }

  const lowercase = 'abcdefghijklmnopqrstuvwxyz';
  const numbers = '0123456789';
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const symbols = '!@#$%^&*()<>,.?/[]{}-=_+|/';

  let hardPassword = '';
  if (levels.includes(1)) hardPassword += lowercase;
  if (levels.includes(2)) hardPassword += uppercase;
  if (levels.includes(3)) hardPassword += numbers;
  if (levels.includes(4)) hardPassword += symbols;
  if (!hardPassword) hardPassword = lightPassword;

  let password = '';
  for (let i = 0; i < passwordLength; i++) {
    password += $getRandomCharacter();
  }
  return password;

  function $getRandomCharacter() {
    const randomIndex = Math.floor(Math.random() * hardPassword.length);
    return hardPassword[randomIndex];
  }

  function $normalizeLevels(levels) {
    // If a single number is provided
    if (Number.isInteger(levels) && levels > 0) {
      return Array.from({ length: levels }, (_, i) => i + 1);
    }

    // If an array is provided, validate it
    if (Array.isArray(levels)) {
      if (
        levels.length === 0 ||
        !levels.every(
          (n, i) => Number.isInteger(n) && n > 0 && (i === 0 || n === levels[i - 1] + 1)
        )
      ) {
        throw new Error('Invalid levels array');
      }

      return levels;
    }

    throw new Error('Levels must be a positive integer or a growing numeric array');
  }
};

export const getLocale = full => {
  const lang = i18n.language;

  if (!full) return lang;

  // Normalize to lowercase for comparison
  const langLower = lang?.toLowerCase?.() || '';

  switch (langLower) {
    case 'pt':
    case 'pt-br':
      return 'pt-BR';

    case 'en':
    case 'en-us':
      return 'en-US';

    default:
      // If already in BCP 47 format (contains hyphen), normalize and return
      if (langLower.includes('-')) {
        const [l, r] = langLower.split('-');
        return `${l}-${r.toUpperCase()}`;
      }
      console.warn('Unrecognized language in getLocale():', lang);
      return lang || 'en-US';
  }
};

export const initCounter = (setCounter, maxCounter, key = 'default', reverse, delay = 1000) => {
  if (reverse) {
    setCounter(maxCounter);

    return (tmr[key] = setInterval(() => {
      setCounter(prev => {
        if (prev === 1) {
          clearInterval(tmr[key]);
          return 0;
        } else {
          return prev - 1;
        }
      });
    }, delay));
  } else {
    setCounter(1);

    return (tmr[key] = setInterval(() => {
      setCounter(prev => {
        if (prev === maxCounter) {
          clearInterval(tmr[key]);
          return maxCounter;
        } else {
          return prev + 1;
        }
      });
    }, delay));
  }
};

export const toPascalCase = str => {
  return str
    .replace(/\w+/g, word => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .replace(/\s+/g, '');
};

export const toCapitalCase = (str, level = 0) => {
  if (!str) return;

  const words = str.split(/\s+/);

  const capitalWords = words.map(word => {
    if (!level || (level === 1 && word.length > 2)) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    } else {
      return word.toLowerCase();
    }
  });

  return capitalWords.join(' ');
};

export const clone = obj => {
  if (!obj || typeof obj !== 'object') return;
  return JSON.parse(JSON.stringify(obj));
};

export const isAntdIcon = icon => typeof icon === 'object';

export const setLocale = (localeKey, isLocaleOn = true) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();

export const normalize = (str, type, level = 0) => {
  if (!str) return;

  str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  if (type === 'lower') {
    return str.toLowerCase();
  } else if (type === 'upper') {
    return str.toUpperCase();
  } else if (type === 'capital') {
    return toCapitalCase(str, level);
  } else {
    return str;
  }
};

export const CounterIcon = props => {
  const { number = 1, fontSize = 22 } = props;

  const iconProps = {
    // className: 'mr-2',
    style: { fontSize: fontSize },
  };

  const iconIdx = number % 10;

  const iconArr = [
    <PiNumberCircleZero key={0} {...props} {...iconProps} />,
    <PiNumberCircleOne key={1} {...props} {...iconProps} />,
    <PiNumberCircleTwo key={2} {...props} {...iconProps} />,
    <PiNumberCircleThree key={3} {...props} {...iconProps} />,
    <PiNumberCircleFour key={4} {...props} {...iconProps} />,
    <PiNumberCircleFive key={5} {...props} {...iconProps} />,
    <PiNumberCircleSix key={6} {...props} {...iconProps} />,
    <PiNumberCircleSeven key={7} {...props} {...iconProps} />,
    <PiNumberCircleEight key={8} {...props} {...iconProps} />,
    <PiNumberCircleNine key={9} {...props} {...iconProps} />,
  ];

  return iconArr[iconIdx];
};

export const getDocumentStatusColor = status => {
  switch (status) {
    case 'not_updated':
      return 'red';

    case 'in_analysis':
    case 'pending_update':
    case 'calibrating':
      return 'orange';

    case 'with_reservation':
      return 'cyan';

    case 'revised':
      return 'blue';

    case 'updated':
    case 'online':
      return 'green';

    case 'archive':
    case 'removed':
    case 'stock':
      return 'gray';

    case 'offline':
    default:
      return 'red';
  }
};

export const getDocumentStatusDescription = status => {
  switch (status) {
    case 'pending_update':
      return 'waiting_for_update';

    case 'not_updated':
      return 'update_expired';

    case 'updated':
      return 'document_updated';

    case 'in_analysis':
      return 'unmoderated_document';

    case 'with_reservation':
      return 'document_with_reservation';

    case 'revised':
      return 'moderated_document';

    case 'stock':
      return 'stored_product';

    default:
      return 'n_a';
  }
};

export const isObjEquals = (objA, objB) => {
  if (!objA || !objB) return;

  let isEquals = true;

  const obj1 = clone(objA);
  const obj2 = clone(objB);

  // reference: https://stackoverflow.com/questions/286141/remove-blank-attributes-from-an-object-in-javascript

  Object.keys(obj1).forEach(k => !obj1[k] && delete obj1[k]);
  Object.keys(obj2).forEach(k => !obj2[k] && delete obj2[k]);

  Object.keys(obj1).map(k => {
    if ((obj1[k] || obj2[k]) && $pure(obj1[k]) !== $pure(obj2[k])) {
      isEquals = false;
    }
    return k;
  });

  Object.keys(obj2).map(k => {
    if ((obj1[k] || obj2[k]) && $pure(obj1[k]) !== $pure(obj2[k])) {
      isEquals = false;
    }
    return k;
  });

  return isEquals;

  function $pure(value) {
    if (!value) return;

    if (typeof value === 'object') {
      return JSON.stringify(value);
    } else if (typeof value !== 'string') {
      return value.toString();
    } else {
      return value;
    }
  }
};

export const isMongoObjectId = str => {
  let regex = /^[0-9a-fA-F]{24}$/;
  return regex.test(str);
};

export const parseDateToDB = date => {
  if (!date || !dayjs.isDayjs(date)) return;
  return dayjs(date);
  // return dayjs(date).toISOString();
};

export const parseDateToDisplay = ({ date, showHours = true, showSeconds = false } = {}) => {
  if (!date) return null;
  return formatDateTimeDefault({ date, showHours, showSeconds });
};

export const parsePhoneToDB = str => {
  if (!str) return;
  return buildPhone(str).numberFull;
};

export const parseCpfToDB = str => {
  if (!str) return;
  return str && returnOnlyNumbers(str);
};

export const parseCpfToDisplay = str => {
  if (!str) return;
  return numberMask(returnOnlyNumbers(str), '999.999.999-99');
};

export const parseCnpjToDB = str => {
  if (!str) return;
  return returnOnlyNumbers(str);
};

export const parseCnpjToDisplay = str => {
  if (!str) return;
  return numberMask(returnOnlyNumbers(str), '99.999.999/9999-99');
};

export const parseNifToDisplay = str => {
  if (!str) return;
  return numberMask(returnOnlyNumbers(str), '999 999 999');
};

export const parseNipcToDisplay = str => {
  if (!str) return;
  return numberMask(returnOnlyNumbers(str), '999 999 999');
};

/**
 * Format IE (Inscricao Estadual) for display based on UF
 */
export const parseIeToDisplay = (str, uf) => {
  if (!str) return;

  // Check for special cases first (ISENTO, etc.)
  const upperStr = str.toString().toUpperCase().trim();
  if (upperStr === 'ISENTO' || upperStr === 'ISENTA') return 'ISENTO';

  // Get only numbers for formatting
  const digits = returnOnlyNumbers(str);
  if (!digits) return str;

  // If no UF provided, try to format based on digit count
  const stateUf = uf?.toUpperCase();

  // IE masks by state
  const ieMasks = {
    // Sao Paulo - 12 digits: 123.456.789.112
    SP: digits.length === 12 ? '999.999.999.999' : null,
    // Rio de Janeiro - 8 digits: 12.345.67-8
    RJ: digits.length === 8 ? '99.999.99-9' : null,
    // Minas Gerais - 13 digits: 123.456.789/0123
    MG: digits.length === 13 ? '999.999.999/9999' : null,
    // Rio Grande do Sul - 10 digits: 123/4567890
    RS: digits.length === 10 ? '999/9999999' : null,
    // Parana - 10 digits: 123.45678-90
    PR: digits.length === 10 ? '999.99999-99' : null,
    // Bahia - 8 or 9 digits: 123456-78 or 1234567-89
    BA: digits.length === 8 ? '999999-99' : digits.length === 9 ? '9999999-99' : null,
    // Santa Catarina - 9 digits: 123.456.789
    SC: digits.length === 9 ? '999.999.999' : null,
    // Goias - 9 digits: 12.345.678-9
    GO: digits.length === 9 ? '99.999.999-9' : null,
    // Pernambuco - 9 digits: 1234567-89
    PE: digits.length === 9 ? '9999999-99' : null,
    // Ceara - 9 digits: 12345678-9
    CE: digits.length === 9 ? '99999999-9' : null,
    // Distrito Federal - 13 digits: 12345678901-23
    DF: digits.length === 13 ? '99999999999-99' : null,
    // Amazonas - 9 digits: 12.345.678-9
    AM: digits.length === 9 ? '99.999.999-9' : null,
    // Para - 9 digits: 12-345678-9
    PA: digits.length === 9 ? '99-999999-9' : null,
    // Espirito Santo - 9 digits: 123456789
    ES: digits.length === 9 ? '999999999' : null,
    // Mato Grosso - 11 digits: 1234567890-1
    MT: digits.length === 11 ? '9999999999-9' : null,
    // Mato Grosso do Sul - 9 digits: 123456789
    MS: digits.length === 9 ? '999999999' : null,
    // Paraiba - 9 digits: 12345678-9
    PB: digits.length === 9 ? '99999999-9' : null,
    // Rio Grande do Norte - 9 or 10 digits
    RN: digits.length === 9 ? '99.999.999-9' : digits.length === 10 ? '99.9.999.999-9' : null,
    // Alagoas - 9 digits: 123456789
    AL: digits.length === 9 ? '999999999' : null,
    // Sergipe - 9 digits: 12345678-9
    SE: digits.length === 9 ? '99999999-9' : null,
    // Piaui - 9 digits: 123456789
    PI: digits.length === 9 ? '999999999' : null,
    // Maranhao - 9 digits: 123456789
    MA: digits.length === 9 ? '999999999' : null,
    // Tocantins - 11 digits: 12345678901
    TO: digits.length === 11 ? '99999999999' : null,
    // Rondonia - 14 digits: 1234567890123-4
    RO: digits.length === 14 ? '9999999999999-9' : null,
    // Acre - 13 digits: 12.345.678/901-23
    AC: digits.length === 13 ? '99.999.999/999-99' : null,
    // Amapa - 9 digits: 123456789
    AP: digits.length === 9 ? '999999999' : null,
    // Roraima - 9 digits: 12345678-9
    RR: digits.length === 9 ? '99999999-9' : null,
  };

  // Get mask for the state
  const mask = stateUf && ieMasks[stateUf];

  // If mask found, apply it
  if (mask) {
    return numberMask(digits, mask);
  }

  // Fallback: return digits without formatting
  return digits;
};

export const parseZipToDB = str => {
  if (!str) return;
  return returnOnlyNumbers(str);
};

export const parseZipToDisplay = str => {
  if (!str) return;
  return numberMask(returnOnlyNumbers(str), '99999-999');
};

export const parseCityToDisplay = (city, region) => {
  if (!city && !region) return;
  if (!region) return city;
  if (!city) return region;
  return `${city} - ${region}`;
};

export const parsePhoneToDisplay = (str, countryCode = 'BR', { showCountryCode = false, masked = false } = {}) => {
  if (!str) return str;

  // Normalize Brazilian mobile numbers missing the 9th digit (old format pre-2014)
  // e.g. +55 34 8825-9583 → +55 34 9 8825-9583
  const normalized = normalizeBrMobile(str, countryCode);

  // Use getPhoneMeta for robust formatting (handles mobile, landline, 0800, 3003, etc.)
  const meta = getPhoneMeta(normalized, countryCode);

  let result;
  if (showCountryCode && meta?.national && meta?.dialCode) {
    // Combine dial code with national format to keep parentheses and hyphens
    // e.g. +55 (34) 9.8825-9583 instead of +55 34 98825 9583
    result = `${meta.dialCode} ${meta.national}`;
  }
  else if (showCountryCode && meta?.international) { result = meta.international; }
  else if (meta?.national) { result = meta.national; }
  else {
    // Fallback: use formatPhoneNumberByCountry to get a properly formatted number
    // even when libphonenumber-js can't parse it (e.g. unusual number lengths)
    const digits = returnOnlyNumbers(str);
    const cc = countryCode || 'BR';
    // Strip country calling code if present (e.g. +55 → digits without 55 prefix)
    let nationalDigits = digits;
    if (str.startsWith('+')) {
      const dialCodes = { BR: '55', US: '1', PT: '351', ES: '34', FR: '33', GB: '44', CN: '86', JP: '81' };
      const dial = dialCodes[cc.toUpperCase()] || '';
      if (dial && digits.startsWith(dial)) nationalDigits = digits.slice(dial.length);
    }
    const fmt = formatPhoneNumberByCountry(nationalDigits, { countryCode: cc });
    if (fmt?.formatted && fmt.formatted !== nationalDigits) {
      result = showCountryCode ? `+${digits.slice(0, digits.length - nationalDigits.length)} ${fmt.formatted}` : fmt.formatted;
    } else {
      result = buildPhone(str)?.phone || str;
    }
  }

  // Mask the phone number: keep first block visible, mask middle blocks, keep last block
  if (masked && result) return maskPhoneDisplay(result);

  return result;
};

/**
 * Mask a formatted phone string: keep first and last blocks, replace digits in middle blocks with *
 * Ex: '+55 19 98232 0000' → '+55 19 9**** 0000'
 * Ex: '(19) 3232-0556' → '(19) 3***-0556'
 */
/**
 * Normalize Brazilian mobile numbers stored in old format (10 national digits)
 * by inserting the missing 9th digit when the number after DDD starts with 6-9.
 * e.g. +553488259583 (10 digits) → +5534988259583 (11 digits)
 * Landlines (digit after DDD 2-5) are left untouched.
 */
function normalizeBrMobile(str, countryCode) {
  if (!str) return str;
  const cc = (countryCode || 'BR').toUpperCase();
  if (cc !== 'BR') return str;

  const digits = returnOnlyNumbers(str);
  // Brazilian number with country code: 55 + 10 national digits = 12 digits total
  // Without country code: 10 national digits
  let nationalDigits;
  if (digits.startsWith('55') && digits.length === 12) {
    nationalDigits = digits.slice(2);
  } else if (!digits.startsWith('55') && digits.length === 10) {
    nationalDigits = digits;
  } else {
    return str; // already 11 digits or not a BR number
  }

  // Check digit after DDD (position 2): 6-9 = mobile missing the 9
  const digitAfterDdd = parseInt(nationalDigits.charAt(2), 10);
  if (digitAfterDdd >= 6 && digitAfterDdd <= 9) {
    // Insert 9 after DDD
    const fixed = nationalDigits.slice(0, 2) + '9' + nationalDigits.slice(2);
    const result = str.startsWith('+') ? `+55${fixed}` : (digits.startsWith('55') ? `55${fixed}` : fixed);
    return result;
  }

  return str;
}

function maskPhoneDisplay(formatted) {
  // Split into blocks by spaces or hyphens while keeping separators
  const parts = formatted.split(/(\s+|-)/);
  // Find indices of blocks that contain digits (skip pure separators)
  const digitBlockIndices = [];
  parts.forEach((part, idx) => {
    if (/\d/.test(part)) digitBlockIndices.push(idx);
  });

  // Need at least 2 digit-blocks to mask; if fewer, mask everything after first digit
  if (digitBlockIndices.length < 2) {
    return formatted.replace(/(\d)(\d+)(\d)/, (_, first, mid, last) =>
      first + mid.replace(/\d/g, '*') + last
    );
  }

  // With exactly 2 digit-blocks (e.g. "+55 3488259583"), mask digits in the last block
  // keeping only the first and last digits visible
  if (digitBlockIndices.length === 2) {
    const lastIdx = digitBlockIndices[1];
    const block = parts[lastIdx];
    const digits = block.replace(/\D/g, '');
    if (digits.length > 2) {
      let digitPos = 0;
      parts[lastIdx] = block.replace(/\d/g, () => {
        digitPos++;
        if (digitPos === 1 || digitPos === digits.length) return digits[digitPos - 1];
        return '*';
      });
    }
    return parts.join('');
  }

  // 3+ digit-blocks: keep first and last blocks visible; mask middle blocks
  // For middle blocks: replace digits with * except the first digit of the block
  const middleIndices = digitBlockIndices.slice(1, -1);
  middleIndices.forEach(idx => {
    const block = parts[idx];
    let firstDigitFound = false;
    parts[idx] = block.replace(/\d/g, d => {
      if (!firstDigitFound) { firstDigitFound = true; return d; }
      return '*';
    });
  });

  return parts.join('');
}

export const buildPhone = fullNumber => {
  if (!fullNumber) return null;
  const isFreeCall =
    fullNumber?.substring(0, 4) === '0800' || fullNumber?.substring(0, 4) === '0300';

  if (isFreeCall) {
    fullNumber = returnOnlyNumbers(fullNumber);
  } else {
    if (fullNumber.slice(0, 1) !== '+') fullNumber = `+55${returnOnlyNumbers(fullNumber)}`;
  }

  const phone = decomposePhoneNumber(fullNumber, isFreeCall);

  return {
    isValid: phone?.isValid || null,
    numberFull: phone?.fullPhoneNumber || null,
    dialCode: phone?.countryCode || null,
    areaCode: phone?.areaCode || null,
    coreNumber: phone?.coreNumber || null,
    core: phone?.core || null,
    number: phone?.phoneNumber || null,
    phone: phone?.phone || null,
    countryCode: phone?.countryIso2?.toLowerCase() || null,
    phoneMask: phone?.phoneMask || null,
  };
};

export const decomposePhoneNumber = (value, isFreeCall) => {
  if (isFreeCall) {
    return {
      phoneNumber: value,
      phoneMask: '9999-999-9999',
      phone: numberMask(value, '9999-999-9999'),
      core: numberMask(value, '9999-999-9999'),
      coreNumber: value,
      areaCode: '',
      fullPhoneNumber: value,
      countryCode: '+55',
      countryIso2: 'BR',
      countryIso3: 'BRA',
    };
  }

  // workaround for landline phone BR
  const landlinePhone =
    value?.length === 13 ? value.slice(0, 5) + '0' + value.slice(5, 13) : undefined;

  const data = phone(landlinePhone || value, {
    country: 'BR',
    validateMobilePrefix: false,
  });

  if (data.isValid) {
    if (landlinePhone) data.phoneNumber = value;

    data.phoneNumber = data.phoneNumber.substring(data.countryCode.length, data.phoneNumber.length);

    data.phoneMask = returnPhoneMask(data.phoneNumber, data.countryIso2);

    data.phone = numberMask(data.phoneNumber, data.phoneMask);

    let i = data.phone.indexOf('(');
    const f = data.phone.indexOf(')');

    data.areaCode = data.phone.substring(++i, f);
    data.core = data.phone.substring(f + 2, data.phone.length);
    data.coreNumber = returnOnlyNumbers(data.core);
    data.fullPhoneNumber = `${data.countryCode}${data.phoneNumber}`;
  } else {
    data.phoneNumber = null;
    data.phoneMask = null;
    data.phone = null;
    data.core = null;
    data.coreNumber = null;
    data.areaCode = null;
    data.fullPhoneNumber = null;
  }

  return data;
};

export const returnPhoneMask = (str, countryCode = 'BR') => {
  if (!str) return;

  countryCode = countryCode.toLowerCase();

  if (countryCode === 'BR') {
    if (str.length === 11) {
      if (str.substring(0, 1) === '0') {
        // 0800-PJMONEY

        return '9999 99 9999';
      } else {
        return '(99) 9.9999-9999';
      }
    } else if (str.length === 10) {
      return '(99) 9999-9999';
    } else {
      return str;
    }
  } else {
    return str;
  }
};

export const numberMask = (value, mask) => {
  let result = '';

  const acceptSpace = false;
  const rule = acceptSpace ? '[0-9] ' : '[0-9]';
  const regex = new RegExp(rule, 'ig');

  if (value) value = returnOnlyNumbers(value);

  let inc = 0;
  Array.from(value).forEach((letter, index) => {
    if (!mask[index + inc]) return result;

    if (!mask[index + inc].match(regex)) {
      setMask(index);
    }

    result += letter;
  });

  return result;

  function setMask(index) {
    result += mask[index + inc];
    inc++;

    if (mask[index + inc] && !mask[index + inc].match(regex)) setMask(index);
  }
};

export const divider = (char = '*', qty = 78) => {
  return char.repeat(qty);
};

export const imageExists = src => {
  const img = new Image();
  img.src = src;
  return img.complete;
};

export const getDateFormatByLocale = locale => {
  if (!locale) locale = dayjs().locale();

  const lc = (locale || '').toString().toLowerCase();

  // DD/MM/YYYY: Brazil, Portugal, and most European/Commonwealth locales
  if (
    lc === 'pt-br' || lc === 'en-br' || lc === 'pt' ||
    lc === 'pt-pt' ||
    lc === 'en-gb' || lc === 'en-au' || lc === 'en-nz' || lc === 'en-in' || lc === 'en-ca' ||
    lc === 'de-de' || lc === 'fr-fr' || lc === 'it-it' || lc === 'es-es' ||
    lc === 'nl-nl' || lc === 'pl-pl' || lc === 'ru-ru'
  ) {
    return 'DD/MM/YYYY';
  }

  // MM/DD/YYYY: US format
  if (lc === 'en-us' || lc === 'en' || lc === 'pt-br-us') {
    return 'MM/DD/YYYY';
  }

  // ISO format (YYYY-MM-DD): fallback
  return 'YYYY-MM-DD';
};

export const buildArrayNumberZeroToLimit = (limit = 0) => {
  return Array.from({ length: limit + 1 }, (_, index) => index);
};

export const getFromLocalStorage = key => {
  switch (key) {
    case 'pageSize':
      return ['10', '20', '50', '100'].includes(localStorage.getItem('pageSize'))
        ? Number(localStorage.getItem('pageSize'))
        : 10;

    default:
      return null;
  }
};

export const debounce = (fn, delay = 200) => {
  if (tmrDebounce) clearTimeout(tmrDebounce);
  tmrDebounce = setTimeout(() => fn(), delay);
};

export const isOdd = (number = 0) => number % 2 === 0;

export const generateUidV4 = () => uuidv4();


export const TAG_COLORS_TABLE = [
  '#C41D7F',
  '#CF1322',
  '#D4380D',
  '#D46B08',
  '#D48806',
  '#D4B106',
  '#7CB305',
  '#389E0D',
  '#08979C',
  '#096DD9',
  '#1D39C4',
  '#531DAB',
];

export const TWITTER_PICKER_DEFAULT_COLORS = [
  '#FF6900',
  '#FCB900',
  '#7BDCB5',
  '#00D084',
  '#8ED1FC',
  '#0693E3',
  '#ABB8C3',
  '#EB144C',
  '#F78DA7',
  '#9900EF',
];

export const getObjectByField = (record, field) => {
  // ex:
  // field: '_metadata.audit.updatedAt'
  // => record['_metadata']['audit']['updatedAt']
  if (!record || !field) return;

  if (Array.isArray(field)) field = field.join('.');

  const keys = field.split('.');
  let result = record;

  for (const key of keys) {
    if (result && typeof result === 'object' && key in result) {
      result = result[key];
    } else {
      return undefined;
    }
  }

  return result;
};

export const simulateApiDelay = (timeout, success, response) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (success) {
        resolve(response);
      } else {
        reject(response);
      }
    }, timeout);
  });
};

export const queue = (component, value = 0) => {
  if (typeof workingQueue[component] === 'undefined') {
    workingQueue[component] = 0;
  }
  workingQueue[component] = workingQueue[component] + value;

  return workingQueue[component];
};

export const strToNumber = valueStr => {
  if (!valueStr) return 0;

  if (!isNaN(valueStr)) {
    return Number(valueStr);
  } else {
    if (valueStr?.includes(',')) {
      return parseFloat(valueStr.replace(/[^\d,-]/g, '').replace(',', '.'));
    } else {
      return parseFloat(valueStr?.replace(/[^\d,.-]/g, ''));
    }
  }
};

export const openUrl = (url, openInNewPage = true) => {
  if (!url) return;
  window.open(url, openInNewPage ? '_blank' : '_self');
};

export const downloadFile = (url, fileName) => {
  // const url = 'https://www.info.com/file.pdf';
  // saveAs(url, 'file.pdf');
  saveAs(url, fileName);
};

export const formatThousandsSeparator = number => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export const InputPlate = props => {
  const [lastSearched, setLastSearched] = useState();

  const {
    onChange,
    elementType,
    profile, // mercosul, brazil, <empty>:automatic
  } = props;

  const PLATES_MASKS = {
    MERCOSUL: '9999999', // 7
    BRAZIL: '999-9999', // 7
  };

  let value = props.value && returnOnlyLettersAndNumbers(props.value);

  if (value) {
    value = applyNumberMask(value, PLATES_MASKS[getMask(value)], true);
  } else {
    value = '';
  }

  // local onChange + parent onChange
  function onLocalChange(ev) {
    let value = returnOnlyLettersAndNumbers(ev.target.value);
    value = applyNumberMask(value, PLATES_MASKS[getMask(value)], true);

    if (value === lastSearched) return;

    setLastSearched(value);
    onChange(ev, value);
  }

  function getMask(value) {
    if (!value) return;

    if (profile) {
      return profile.toUpperCase();
    } else {
      const joker = value.substring(4, 5);

      if (!isNaN(parseInt(joker))) return 'BRAZIL';

      return 'MERCOSUL';
    }
  }

  if (props.antd === 'Input.Search') {
    return (
      <Input.Search
        {...props}
        // ref={ref}
        type={elementType}
        value={value}
        onChange={onLocalChange}
      />
    );
  } else {
    return (
      <Input
        {...props}
        // ref={ref}
        type={elementType}
        value={value}
        onChange={onLocalChange}
      />
    );
  }
};

// InputPlate.propTypes = {
//   value: PropTypes.string,
//   profile: PropTypes.string,
//   onChange: PropTypes.func,
// }

export const returnOnlyLettersAndNumbers = str => {
  if (!str) return;

  const regex = /[A-Za-z0-9]+/g;
  const result = str.match(regex);

  return result ? result.join('').toUpperCase() : '';
};

export const isValidPlate = plate => {
  const str = returnOnlyLettersAndNumbers(plate);
  const patternBrazil = /^[A-Za-z]{3}\d{4}$/;
  const patternMercosul = /^[A-Za-z]{3}\d[A-Za-z]\d{2}$/;

  return patternBrazil.test(str) || patternMercosul.test(str);
};

export const isArrayIncludes = (arrA, arrB, path) => {
  if (path) {
    return arrB.some(objB => arrA.includes(objB?.[path]));
  } else {
    return arrB.some(objB => arrA.includes(objB));
  }
};

/**
 * Asserts that an object contains a required key. Throws if missing.
 */
export const assertParamExists = (param, key, context = 'Object') => {
  if (!param?.[key]) {
    throw new Error(`${context}: (${key}) key is missing`);
  }
};

export const assertExists = (field, value) => {
  if (!value) throw new Error(`Missing ${field} value!`);
};

export const throwError = (message, error) => {
  if (message && error) {
    throw new Error(`${message}: ${error}.`);
  } else {
    throw new Error(message);
  }
};

export const getItemFromArray = (docs, path, field, value) => {
  const root = docs?.[0]?.[path] || docs?.[path];
  return root?.find(i => i?.[field]?.toLowerCase() === value?.toLowerCase());
};

export const parseParametersArray = (arr, obj, field) => {
  return arr?.filter(i => (i._id !== obj?.[field] && !i.removedAt) || i._id === obj?.[field]) || [];
};

/**
 * Replace route params in a URI template
 */
export const fillRouteParams = (uri, params = {}) => {
  if (!params || typeof params !== 'object' || Object.keys(params).length === 0) {
    return uri;
  }

  return uri.replace(/:([a-zA-Z0-9_]+)/g, (_, key) => {
    return params[key] !== undefined ? encodeURIComponent(params[key]) : `:${key}`;
  });
};

/**
 * Append a query string to a URI, supporting nested objects via JSON.stringify
 */
export const fillRouteQueryString = (uri, query) => {
  if (!query || typeof query !== 'object' || Object.keys(query).length === 0) {
    return uri;
  }

  const searchParams = new URLSearchParams();

  for (const key in query) {
    const value = query[key];
    if (value != null) {
      const stringValue = typeof value === 'object' ? JSON.stringify(value) : String(value);
      searchParams.append(key, stringValue);
    }
  }

  const queryString = searchParams.toString();
  return queryString ? `${uri}?${queryString}` : uri;
};

/**
 * Build a full URL by concatenating base, path, route params, and query string
 */

export const parseToUrl = (url, endpoint, params, query) => {
  if (!url || typeof url !== 'string') return null;

  const base = endpoint && typeof endpoint === 'string' ? `${url}${endpoint}` : url;
  const withParams = params && typeof params === 'object' ? fillRouteParams(base, params) : base;

  const resultUrl =
    query && typeof query === 'object' ? fillRouteQueryString(withParams, query) : withParams;

  return resultUrl
    .split('/')
    .filter(segment => !(segment.startsWith(':') && segment.endsWith('?')))
    .join('/')
    .replace(/\/+$/, ''); // remove barra(s) no final
};

export const parseFromUrl = (fullUrl = null, base = '', endpoint = '') => {
  // 1) Resolve source URL
  const resolvedHref =
    typeof fullUrl === 'string' && fullUrl
      ? fullUrl
      : typeof window !== 'undefined'
        ? window.location.href
        : '';

  const urlObj = safeBuildURL(resolvedHref);
  if (!urlObj) {
    return {
      url: resolvedHref || '',
      urlSchema: base && endpoint ? `${base}${endpoint}` : null,
      pathname: null,
      params: {},
      query: {},
    };
  }

  // 2) Basic pieces
  const url = urlObj.href;
  const pathname = urlObj.pathname;
  const urlSchema =
    typeof base === 'string' && typeof endpoint === 'string' && (base || endpoint)
      ? `${stripTrailingSlash(base || '')}${endpoint || ''}`
      : null;

  // 3) Query parsing (supports double-encoding and JSON values)
  const query = {};
  urlObj.searchParams.forEach((raw, key) => {
    const decoded = multiDecode(raw);
    query[key] = tryParseJSON(decoded);
  });

  // 4) Params by matching endpoint template against path minus base
  const params = {};
  if (urlSchema) {
    const basePath = stripTrailingSlash(base || '');
    const pathAfterBase =
      basePath && pathname.startsWith(basePath) ? pathname.slice(basePath.length) || '/' : pathname;

    const tmplSegs = toSegments(endpoint || '');
    const pathSegs = toSegments(pathAfterBase);

    // Iterate template, bind :params and tolerate optional segments (:id?)
    let j = 0;
    for (let i = 0; i < tmplSegs.length && j < pathSegs.length; i++, j++) {
      const t = tmplSegs[i];
      const p = pathSegs[j];

      if (t.startsWith(':')) {
        const isOptional = t.endsWith('?');
        const key = t.replace(/^:/, '').replace(/\?$/, '');

        if (p !== undefined && p !== null && p !== '') {
          params[key] = p;
        } else if (!isOptional) {
          // required param missing -> keep undefined
          params[key] = undefined;
        }
      } else {
        // literal segment must match; if not, try to realign once
        if (t !== p) {
          // try a single-step realign if optional template segments follow
          const aheadOptional = tmplSegs
            .slice(i + 1)
            .some(s => s.startsWith(':') && s.endsWith('?'));
          if (aheadOptional) {
            i--; // keep template, advance path only
            continue;
          } else {
            // stop matching if literals diverge
            break;
          }
        }
      }
    }

    // Also capture trailing optional params without consuming path
    for (let k = 0; k < tmplSegs.length; k++) {
      const t = tmplSegs[k];
      if (t.startsWith(':') && t.endsWith('?')) {
        const key = t.replace(/^:/, '').replace(/\?$/, '');
        if (!(key in params)) params[key] = undefined;
      }
    }
  }

  return { url, urlSchema, pathname, params, query };

  // HELPERS (internal)
  function safeBuildURL(href) {
    try {
      // Accept absolute or relative
      return new URL(href, typeof window !== 'undefined' ? window.location.origin : 'http://x');
    } catch {
      return null;
    }
  }
  function stripTrailingSlash(s) {
    return s ? s.replace(/\/+$/, '') : s;
  }
  function toSegments(p) {
    return (p || '/')
      .split('?')[0]
      .split('#')[0]
      .split('/')
      .filter(Boolean)
      .map(x => decodeURI(x));
  }
  function multiDecode(v) {
    let prev = v;
    let cur = safeDecode(prev);
    // Decode repeatedly until stable to handle double-encoded payloads
    while (cur !== prev) {
      prev = cur;
      cur = safeDecode(prev);
    }
    return cur;
  }
  function safeDecode(v) {
    try {
      return decodeURIComponent(v);
    } catch {
      return v;
    }
  }
  function tryParseJSON(v) {
    const s = typeof v === 'string' ? v.trim() : v;
    if (typeof s !== 'string' || !s) return s;
    const first = s[0];
    const last = s[s.length - 1];
    if ((first === '{' && last === '}') || (first === '[' && last === ']')) {
      try {
        return JSON.parse(s);
      } catch {
        return s;
      }
    }
    return s;
  }
};

export const buildQueryFromObject = queryObject => {
  if (
    !queryObject ||
    typeof queryObject !== 'object' ||
    Array.isArray(queryObject) ||
    Object.keys(queryObject).length === 0
  ) {
    return '';
  }

  const cleanedObject = Object.fromEntries(
    Object.entries(queryObject).filter(([_, value]) => value !== null && value !== undefined)
  );

  return Object.entries(cleanedObject)
    .map(([key, value]) => {
      try {
        const rawValue =
          typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean'
            ? value
            : JSON.stringify(value);

        const encodedValue = encodeURIComponent(rawValue);
        return `${key}=${encodedValue}`;
      } catch (error) {
        console.warn(`Erro ao serializar chave "${key}"`, error);
        return null;
      }
    })
    .filter(Boolean)
    .join('&');
};

export const removeFunctionsFromObject = obj => {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => typeof value !== 'function')
  );
};

export const substitution = (str, from, to) => {
  if (!str || !from || !to) {
    console.error('abort substitution()');
    return str;
  }

  if (!Array.isArray(from)) from = new Array(from);
  if (!Array.isArray(to)) to = new Array(to.toString());

  if (from.length !== to.length) {
    console.error('abort substitution()');
    return str;
  }

  for (let i = 0; i < from.length; i++) {
    str = str.replaceAll(from[i], to[i]);
  }

  return str;
};

export const generateMongoObjectId = () => {
  const hex = () =>
    Math.floor(Math.random() * 0xffffffff)
      .toString(16)
      .padStart(8, '0');

  const timestamp = Math.floor(Date.now() / 1000)
    .toString(16)
    .padStart(8, '0');
  const random = hex().substring(0, 8); // 4 bytes
  const counter = hex().substring(0, 8); // 4 bytes

  return (timestamp + random + counter).substring(0, 24); // 24 hex chars
};

export const includesObjectKeyFragment = (obj, keyFragment) => {
  if (
    !obj ||
    !Object?.keys(obj).length ||
    typeof obj !== 'object' ||
    !keyFragment ||
    typeof keyFragment !== 'string'
  ) {
    return false;
  }

  return Object.keys(obj).some(key => key.includes(keyFragment));
};

export const normalizeBoolean = value => {
  if (typeof value !== 'string') return Boolean(value);

  const val = value.trim().toLowerCase();

  return ['sim', 's', '1', 'true', 'yes', 's'].includes(val?.toString()?.toLowerCase());
};

export const chunkArray = (array, size) =>
  Array.from({ length: Math.ceil(array.length / size) }, (_, i) =>
    array.slice(i * size, i * size + size)
  );

export const mergeObjectsDeep = (...objects) => {
  // Deep-clone first object as base, or empty object if none provided
  const result = objects.length > 0 ? JSON.parse(JSON.stringify(objects[0])) : {};

  // Recursive merge helper
  function mergeDeep(target, source) {
    for (const key in source) {
      const isSourceObject = source[key] instanceof Object && !(source[key] instanceof Array);
      const isTargetObject = target[key] instanceof Object && !(target[key] instanceof Array);

      if (isSourceObject && isTargetObject) {
        // Both are objects: merge recursively
        mergeDeep(target[key], source[key]);
      } else {
        // Otherwise overwrite value
        target[key] = source[key];
      }
    }
  }

  // Merge all objects starting from the second
  for (let i = 1; i < objects.length; i++) {
    mergeDeep(result, objects[i]);
  }

  return result;
};

export const SubIndicator = props => {
  if (props.counts) {
    return (
      <p className="mb-0 mr-2">
        {props.icon}
        <span className="ml-1">{props.counts}</span>
      </p>
    );
  }
  return null;
};

export const buildObjectFromStringOrArray = fieldStringOrArray => {};

export const isPhoneValid = phone => {
  const regex = /^\+?[1-9]\d{7,14}$/; // E.164
  return regex.test(phone || '');
};

export const ensureArray = value => {
  if (Array.isArray(value)) return value;
  if (value && typeof value === 'object') return Object.values(value);
  return [];
};

export const isMobileView = () => {
  // return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  //   navigator.userAgent
  // );

  return typeof window !== 'undefined' && window.innerWidth < 768;
};

export const genKey = prefix => `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;

// ============================================================================
// FUNCTIONS CONSOLIDATED FROM helpers2.js
// ============================================================================

/**
 * @function extractNodeText
 * @description Extract plain text from a ReactNode-like structure
 */
function extractNodeText(node) {
  if (node == null || typeof node === 'boolean') return '';
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  if (Array.isArray(node)) return node.map(extractNodeText).join(' ');
  // React element with props.children
  if (node?.props?.children) return extractNodeText(node.props.children);
  // Fallback
  return '';
}

/**
 * @function defaultSelectFilterOption
 * @description Case/diacritics-insensitive filter that supports ReactNode labels.
 */
export const defaultSelectFilterOption = (input, option, field = 'index') => {
  if (!input || !option) return false;

  const find = normalize(String(input), 'lower');

  let text = '';
  if (option[field]) {
    text = normalize(String(option[field]), 'lower');
  } else if (option.text) {
    // text pode ser string ou ReactNode
    const raw = typeof option.text === 'string' ? option.text : extractNodeText(option.text);
    text = normalize(String(raw), 'lower');
  } else if (option.label) {
    // label pode ser string ou ReactNode
    const raw = typeof option.label === 'string' ? option.label : extractNodeText(option.label);
    text = normalize(String(raw), 'lower');
  } else if (option.children) {
    const raw =
      typeof option.children === 'string' ? option.children : extractNodeText(option.children);
    text = normalize(String(raw), 'lower');
  } else {
    text = ''; // nothing useful to search
  }

  return text.indexOf(find) >= 0;
};
